/**
 * Export an array of row objects to a CSV file download.
 */
export function downloadCsv(rows: Record<string, unknown>[], filename: string): void {
  if (!rows.length) return;

  const headers = Object.keys(rows[0]!);
  const lines = [
    headers.map(escapeCsvField).join(','),
    ...rows.map((r) =>
      headers.map((h) => escapeCsvField(String(r[h] ?? ''))).join(','),
    ),
  ];

  const blob = new Blob([lines.join('\n')], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${filename}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}

function escapeCsvField(value: string): string {
  if (value.includes(',') || value.includes('"') || value.includes('\n')) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}
